module.exports = __webpack_public_path__ + "assets/img/coach-image.1ac494fe.jpg";